import React, { useState } from "react";
import "./Login_signup.css";
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Reset_Password_Modal from "./Reset_Password_Modal";
// import Success_Modal from '../success_modal/Success_Modal';
import { useNavigate } from "react-router-dom";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Successfull_Modal from "../common-modal/successfull_modal/Successfull_Modal";
import { Link } from "react-router-dom";
import Signup_Modal from "./Signup_Modal";
import { CreateLogin } from "../../../../features/admin/auth/Slice";
import { useDispatch } from "react-redux";

const Login_With_Mobile = ({ setSelectedModal, setShowResetModal, setShowSucsessModal, setSuccessText, ...props }) => {
  const {
    control,
    register, setError,
    handleSubmit, reset,
    formState: { errors },
  } = useForm();


  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const [showSignUp, setShowSignUp] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const dispatch = useDispatch();


  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const LoginWithMobile = async (params) => {

    const sendData = new FormData();
    sendData.append("contact_no", params?.contact_no);
    sendData.append("password", params?.password);
    const res = await dispatch(CreateLogin(sendData));

    if (res.meta?.requestStatus === "fulfilled") {
      reset()

      setSuccessText("Login Succesfully !");
      props?.onHide()
      setShowSucsessModal(true)
      setTimeout(() => {
        navigate(0);
        setShowSucsessModal(false);
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res?.payload?.errors?.password) {
        setError("password", {
          type: "manual",
          message: res?.payload?.errors?.password || "Something Is Wrong"
        });
      }
      if (res?.payload?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res?.payload?.errors?.contact_no || "Something Is Wrong"
        });
      }

    }


  }
  return (
    <>
      <div className="login_div">
        <div className="login_form_div">
          <div className="tagline_div">
            <p className="tagline">Your jousssssssrney starts here</p>
            <p className="tagline">Take the first step</p>
          </div>

          <Form>
            <Form.Group className="gray_input_group input_group">
              <Form.Label>Contact</Form.Label>
              <Form.Control
                placeholder="Contact Number"
                type={"text"}
                name="contact_no"
                {...register("contact_no", {
                  required: "Contact Number  is required",
                  required: "Contact Number is required",
                  pattern: {
                    value: /^[0-9]+$/,  // only numbers
                    message: "Only digits are allowed",
                  },
                  minLength: {
                    value: 10,
                    message: "Contact Number must be exactly 10 digits",
                  },
                  maxLength: {
                    value: 10,
                    message: "Contact Number must be exactly 10 digits",
                  },
                })}
              />
              {errors?.contact_no && (
                <Form.Text className="text-danger">{errors.contact_no.message}</Form.Text>
              )}
            </Form.Group>

            <Form.Group className="gray_input_group input_group">
              <div className="password_holder">
                <Form.Control
                  placeholder="Confirm Password"
                  type={showPasswordOne ? "text" : "password"}
                  name="password"
                  {...register("password", {
                    required: "Password  is required",
                  })}
                  onChange={(e) => setPasswordAgain(e.target.value)}
                />

                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconTwo}
                    className="icon"
                    onClick={() => togglePasswordVisibility("reenterPassword")}
                  />
                </div>
              </div>

              <p
                className="link_text dark_text"
                onClick={() => {
                  props?.onHide();
                  setShowResetModal(true); // Changed this line
                }}
              >
                Forgot Password?
              </p>

              {errors?.password && (
                <Form.Text className="text-danger">{errors.password.message}</Form.Text>
              )}
            </Form.Group>
          </Form>
        </div>

        <div className="btn_holder">
          <Light_Black_Btn
            btnText="Login"
            onClick={handleSubmit(LoginWithMobile)}
          // onClick={() => {
          //   setSuccessText("Login Succesfully !");
          //   props?.onHide()
          //   setShowSucsessModal(true)
          //   setTimeout(() => {
          //     navigate("/home");
          //     setShowSucsessModal(false);
          //   }, 3000);
          // }}
          />
        </div>

        {/* <div className="or_text_div">
          <p className="or_txt">Or</p>
        </div> */}

        {/* <div className="text-center logguest_div">
          <Link to={"/home"}>
            <button className="logguest_btn">Log in as Guest</button>
          </Link>
        </div> */}

        <p className="dark_text">
          Don't have an account?
          <span
            className="link_text"
            onClick={() => {
              setSelectedModal("sign_up");
            }}
          >
            {" "}
            Create Account
          </span>
          .
        </p>
      </div>


    </>
  );
};

export default Login_With_Mobile;
